import { ModuleManager, SectionList } from "@module-system";

import component from "./Components/Announcement.vue";
import configurationProvider from "@/Core/configurationProvider";

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "Announcement",
  version: "1.0.0",
  register() {
    ModuleManager.addViewModule({
      key: "announcement",
      section: SectionList.CallTopBar,
      ViewComponent: component,
      Condition: (rtcId) => {
        return configurationProvider.getBool("CALL_ANNOUNCEMENTS_ENABLED", true);
      }
    });
  },
};
export default module;